function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg007Discover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.647 508.647",
    style: {
      enableBackground: "new 0 0 508.647 508.647"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#231F20"
    },
    d: "M0,215.659c-0.005-1.323,0.191-1.804,1.691-1.782   c7.694,0.109,15.396-0.106,23.085,0.133c11.312,0.352,21.591,3.648,29.975,11.638c5.771,5.498,9.398,12.23,10.826,20.04   c2.844,15.56-1.543,28.763-13.396,39.319c-6.471,5.762-14.225,8.659-22.791,9.35c-9.441,0.762-18.909,0.156-28.362,0.362   c-1.131,0.025-1.005-0.586-1.004-1.296C0.032,285.458,0.049,228.539,0,215.659z M15.739,279.526   c-0.006,1.094,0.223,1.444,1.381,1.429c3.152-0.041,6.31-0.009,9.443-0.36c5.721-0.641,11.087-2.282,15.275-6.473   c7.04-7.043,9.627-15.609,7.672-25.3c-1.969-9.761-7.587-16.639-17.329-19.658c-4.745-1.47-9.679-1.378-14.59-1.44   c-1.399-0.018-1.884,0.259-1.868,1.795C15.81,237.799,15.786,271.138,15.739,279.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#231F20"
    },
    d: "M477.528,260.832c8.462,11.317,16.79,22.455,25.32,33.863   c-1.328,0-2.366,0-3.404,0c-4.758,0-9.518-0.074-14.274,0.044c-1.441,0.036-2.167-0.501-2.914-1.62   c-6.596-9.887-13.249-19.736-19.885-29.597c-0.089-0.133-0.198-0.259-0.258-0.405c-0.401-0.985-1.263-0.92-2.027-0.763   c-0.843,0.174-0.44,0.965-0.442,1.462c-0.026,9.677-0.062,19.354,0.023,29.03c0.014,1.609-0.463,1.922-1.959,1.885   c-4.167-0.107-8.34-0.068-12.509-0.016c-1.051,0.014-1.478-0.177-1.477-1.371c0.035-26.037,0.03-52.074,0.013-78.11   c0-0.883,0.094-1.36,1.185-1.336c8.976,0.187,17.963-0.358,26.929,0.33c6.226,0.478,12.082,2.162,16.869,6.406   c5.742,5.092,7.359,11.773,6.968,19.131c-0.574,10.823-6.472,17.969-16.981,20.633C478.352,260.487,478.015,260.65,477.528,260.832   z M459.626,238.94c0,3.575,0.064,7.152-0.035,10.724c-0.035,1.253,0.363,1.499,1.513,1.452c2.343-0.096,4.686-0.045,7.03-0.292   c6.86-0.724,10.762-4.689,11.271-11.561c0.41-5.533-2.418-9.718-7.681-11.444c-3.461-1.135-7.032-1.011-10.599-1.081   c-1.165-0.023-1.562,0.231-1.53,1.477C459.686,231.788,459.626,235.364,459.626,238.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#231F20"
    },
    d: "M388.79,215.49c-0.004-1.212,0.242-1.608,1.549-1.603   c13.898,0.053,27.796,0.045,41.694,0.009c1.082-0.003,1.473,0.209,1.448,1.381c-0.079,3.74-0.078,7.484,0,11.224   c0.024,1.128-0.395,1.279-1.369,1.275c-8.606-0.033-17.213,0.021-25.818-0.058c-1.463-0.013-1.755,0.413-1.73,1.786   c0.086,4.863,0.076,9.729,0.003,14.592c-0.018,1.215,0.323,1.509,1.516,1.502c8.285-0.053,16.571,0.006,24.856-0.063   c1.309-0.011,1.56,0.392,1.534,1.594c-0.077,3.58-0.076,7.163,0.001,10.743c0.024,1.132-0.299,1.401-1.41,1.395   c-8.232-0.049-16.464,0.018-24.695-0.067c-1.535-0.016-1.819,0.469-1.803,1.876c0.074,6.093,0.064,12.187,0.004,18.281   c-0.012,1.212,0.24,1.611,1.548,1.601c8.605-0.066,17.212-0.003,25.818-0.067c1.285-0.009,1.573,0.357,1.546,1.58   c-0.081,3.686-0.055,7.377-0.011,11.065c0.011,0.883-0.206,1.183-1.143,1.181c-14.112-0.029-28.224-0.04-42.336,0.013   c-1.285,0.005-1.183-0.623-1.182-1.462C388.819,280.223,388.833,228.372,388.79,215.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#231F20"
    },
    d: "M105.435,271.356c2.126,3.977,4.931,7.216,9.06,9.03   c4.438,1.95,9.007,2.63,13.614,0.57c4.186-1.87,6.447-5.208,6.627-9.753c0.179-4.502-2.23-7.518-6.13-9.465   c-4.483-2.238-9.331-3.567-13.912-5.557c-4.477-1.945-8.742-4.195-11.833-8.178c-1.889-2.433-2.937-5.215-3.303-8.194   c-1.632-13.266,5.633-22.754,16.653-25.872c11.51-3.257,21.876-0.395,31.161,6.902c0.686,0.539,0.921,0.919,0.264,1.742   c-2.364,2.961-4.675,5.966-6.909,9.025c-0.679,0.931-0.975,0.667-1.594,0.007c-2.526-2.696-5.425-4.879-9.182-5.416   c-4.742-0.678-9.228-0.071-12.529,3.86c-2.951,3.514-2.296,7.94,1.432,10.588c3.337,2.37,7.226,3.564,10.989,5.018   c3.528,1.364,6.974,2.888,10.272,4.758c6.729,3.815,10.427,9.411,10.909,17.253c0.813,13.24-6.148,24.423-19.113,27.754   c-13.833,3.554-27.349-0.383-36.223-13.482c-0.366-0.541-0.406-0.857,0.098-1.335C98.999,277.563,102.182,274.483,105.435,271.356z   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#231F20"
    },
    d: "M304.165,213.92c5.483,0,10.72,0.035,15.955-0.03   c1.048-0.013,1.457,0.363,1.819,1.28c4.819,12.2,18.706,47.136,20.839,52.528c0.974-1.075,14.849-36.266,21.39-52.583   c0.261-0.651,0.448-1.225,1.399-1.217c5.342,0.047,10.684,0.023,16.253,0.023c-1.271,3.052-24.152,57.343-34.336,81.586   c-0.403,0.96-0.85,1.274-1.851,1.236c-2.028-0.077-4.062-0.072-6.09-0.001c-0.903,0.032-1.311-0.298-1.646-1.11   c-6.276-15.223-28.295-68.418-33-79.805C304.655,215.245,304.444,214.651,304.165,213.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#231F20"
    },
    d: "M218.246,235.762c-2.979-2.85-5.835-5.244-9.246-6.822   c-13.421-6.206-29.578,0.46-34.751,14.694c-3.984,10.964-2.658,21.389,5.347,30.292c5.353,5.953,12.425,8.125,20.312,8.042   c6.257-0.065,11.434-2.61,16.01-6.653c0.674-0.595,1.325-1.215,1.98-1.818c0.569,0.311,0.334,0.793,0.335,1.168   c0.018,5.292,0.002,10.585,0.023,15.878c0.003,0.803-0.116,1.293-0.988,1.713c-16.207,7.804-36.709,4.715-49.389-8.265   c-7.847-8.032-11.711-17.729-11.955-28.954c-0.413-18.993,12.242-35.556,29.847-40.876c10.802-3.264,21.349-2.639,31.523,2.467   c0.547,0.274,0.973,0.511,0.969,1.268C218.232,223.721,218.246,229.544,218.246,235.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#231F20"
    },
    d: "M89.417,292.933c0.005,1.327-0.192,1.85-1.71,1.806   c-4.273-0.126-8.553-0.076-12.829-0.021c-1.038,0.014-1.357-0.253-1.356-1.325c0.029-26.035,0.031-52.071-0.003-78.106   c-0.002-1.173,0.386-1.404,1.461-1.39c4.223,0.057,8.448,0.086,12.669-0.012c1.398-0.033,1.784,0.303,1.777,1.744   C89.363,228.566,89.371,280.102,89.417,292.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#231F20"
    },
    d: "M506.362,220.237c0.764,1.021,1.516,2.027,2.286,3.057   c-0.12,0-0.214,0-0.307,0c-0.43,0-0.859-0.007-1.289,0.004c-0.129,0.004-0.195-0.045-0.263-0.146   c-0.595-0.893-1.196-1.782-1.795-2.672c-0.008-0.012-0.018-0.023-0.023-0.036c-0.036-0.09-0.114-0.084-0.183-0.07   c-0.076,0.016-0.04,0.087-0.04,0.132c-0.002,0.873-0.006,1.747,0.002,2.621c0.002,0.145-0.042,0.174-0.177,0.17   c-0.376-0.009-0.753-0.006-1.129-0.001c-0.095,0.001-0.133-0.016-0.133-0.124c0.003-2.35,0.003-4.701,0.002-7.051   c0-0.08,0.008-0.122,0.107-0.121c0.81,0.017,1.621-0.032,2.431,0.029c0.562,0.043,1.09,0.195,1.523,0.579   c0.518,0.459,0.664,1.063,0.629,1.727c-0.052,0.977-0.584,1.622-1.533,1.863C506.436,220.205,506.405,220.22,506.362,220.237z    M504.745,218.26c0,0.323,0.007,0.646-0.003,0.968c-0.003,0.113,0.033,0.136,0.137,0.132c0.212-0.009,0.423-0.004,0.634-0.027   c0.62-0.065,0.971-0.423,1.017-1.043c0.037-0.499-0.218-0.878-0.693-1.033c-0.312-0.102-0.635-0.091-0.957-0.098   c-0.105-0.001-0.142,0.021-0.138,0.133C504.751,217.614,504.745,217.937,504.745,218.26z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.8599,
    y1: 215.5098,
    x2: 284.0583,
    y2: 293.1373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#E45E26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8A020"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_1_)"
    },
    cx: 265.959,
    cy: 254.324,
    rx: 42.691,
    ry: 42.843
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.5529,
    y1: 217.2469,
    x2: 287.3653,
    y2: 291.4002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#80391B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1105,
    style: {
      stopColor: "#843B1B",
      stopOpacity: 0.8161
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2346,
    style: {
      stopColor: "#92401D",
      stopOpacity: 0.6096
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3653,
    style: {
      stopColor: "#A8481F",
      stopOpacity: 0.3922
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4996,
    style: {
      stopColor: "#C75323",
      stopOpacity: 0.1687
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601,
    style: {
      stopColor: "#E45E26",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8A020",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_2_)"
    },
    cx: 265.959,
    cy: 254.324,
    rx: 42.691,
    ry: 42.843
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg007Discover);
export default __webpack_public_path__ + "static/media/007-discover.ff61d297dccbbb4daf270286a8423e45.svg";
export { ForwardRef as ReactComponent };